import http from '@/lib/request/svc-url/_http';
import { logWebHrError } from "@/core/logger/log-wrapper";

const url = 'auth/token';

export default function auth(tempToken) {
  http.defaults.headers.common['Authorization'] = `Bearer ${tempToken}`;

  if (process.env.MOCK) {
    return Promise.resolve(() => process.env.MOCK_ONBOARDING_ID);
  }

  return http
    .get(url)
    .then(({ data }) => (data && data.data ? data.data.token : ''))
    .catch(error => {
      logWebHrError({
        message: 'Failed to authenticate token',
        source: 'auth',
        error,
      });

      throw error;
    });
}
